// @flow
import type { Passengers } from "booking/services/reservation/types"

// { adult: 2, teen: 1, child: 0, infant: 1 } => "2-1-0-1"
const passengersCountHash = (passengers: Passengers) =>
  `${passengers.adult}-${passengers.teen || 0}-${passengers.child}-${passengers.infant}`

export const hashToPassengers = (hash: string = "1"): Passengers => {
  // $FlowFixMe https://github.com/facebook/flow/issues/183
  const splitted = hash.split("-").map(i => parseInt(i))
  if (splitted.length <= 3) {
    // backward compatibility, format: adult-child-infant
    const [adult = 0, child = 0, infant = 0] = splitted

    return { adult, teen: 0, child, infant }
  }

  const [adult = 0, teen = 0, child = 0, infant = 0] = splitted
  return { adult, teen, child, infant }
}

export default passengersCountHash
